var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-button',{attrs:{"icon":"add","type":"line","size":"small","color":"primary"}},[_c('b',{staticStyle:{"font-size":"14px"}},[_vm._v("Gerar Remessas")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }